import React, { useEffect, useRef, useState } from "react";
import { HiFilter, HiPlus, HiSearch } from "react-icons/hi";
import { TbFileTypePdf } from "react-icons/tb";
import UsersTable from "./UsersTable";
import CardWidget from "./CardWidget";

const EngagedUsers = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLanguageOption, setSelectedLanguageOption] = useState("Odia");
  const [selectedLocationOption, setSelectedLocationOption] =  useState("Odisha");
  const [activeTab, setActiveTab] = useState("Language Wise");
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOptionClick = (option) => {
    if (activeTab === "Language Wise") {
      setSelectedLanguageOption(option);
    } else {
      setSelectedLocationOption(option);
    }
    setIsDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getDropdownOptions = () => {
    if (activeTab === "Language Wise") {
      return ["Odia", "English", "Tamil", "Bhojpuri"];
    } else if (activeTab === "Location Wise") {
      return ["Odisha", "Delhi", "Mumbai", "Chennai"];
    }
    return ["All Users"];
  };

  return (
    <React.Fragment>
      <div className="py-5">
        <div className="flex flex-col">
          <div className="hidden sm:flex">
            <button
              className={`rounded-tl-2xl border-none bg-white px-16 py-2 text-lg tracking-wide text-navy-700 focus:outline-none ${
                activeTab === "Language Wise"
                  ? "bg-gradient-to-br from-[#f8b7d5] to-white font-semibold"
                  : "bg-transparent"
              }`}
              onClick={() => setActiveTab("Language Wise")}
            >
              Language Wise
            </button>
            <button
              className={`rounded-tr-2xl border-none bg-white px-16 py-2 text-lg tracking-wide text-navy-700 focus:outline-none ${
                activeTab === "Location Wise"
                  ? "bg-gradient-to-bl from-[#f8b7d5] to-white font-semibold"
                  : "bg-transparent"
              }`}
              onClick={() => setActiveTab("Location Wise")}
            >
              Location Wise
            </button>
          </div>

          <div className="mb-4 flex justify-center space-x-4 sm:hidden">
            <label className="flex items-center space-x-2">
              <input
                type="radio"
                name="tab"
                value="Language Wise"
                checked={activeTab === "Language Wise"}
                onChange={() => setActiveTab("Language Wise")}
                className="form-radio text-[#c51369]"
              />
              <span className="text-gray-700">Language Wise</span>
            </label>
            <label className="flex items-center space-x-2">
              <input
                type="radio"
                name="tab"
                value="Location Wise"
                checked={activeTab === "Location Wise"}
                onChange={() => setActiveTab("Location Wise")}
                className="form-radio text-[#c51369]"
              />
              <span className="text-gray-700">Location Wise</span>
            </label>
          </div>

          <div className="flex flex-col items-center justify-between space-y-4 bg-white p-5 shadow-sm sm:max-w-full sm:rounded-b-2xl sm:rounded-tr-2xl sm-max:rounded-2xl md:flex-row md:space-y-0">
            {/* dropdown */}
            <div
              className="md:min-w-1/5 relative w-full md:w-1/5"
              ref={dropdownRef}
            >
              <button
                className="flex w-full items-center rounded-md border bg-white px-4 py-2 tracking-wide text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#c51369]"
                onClick={toggleDropdown}
              >
                <HiFilter color="#c51369" className="mr-2 h-5 w-5" />
                {activeTab === "Language Wise"
                  ? selectedLanguageOption
                  : selectedLocationOption}
              </button>
              {isDropdownOpen && (
                <div className="absolute left-0 z-10 mt-2 w-full min-w-max rounded-md border bg-white shadow-lg md:w-auto">
                  <ul className="py-2">
                    {getDropdownOptions()?.map((option) => (
                      <li
                        key={option}
                        className="cursor-pointer px-4 py-2 hover:bg-gray-100"
                        onClick={() => handleOptionClick(option)}
                      >
                        {option}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* search bar */}
            <div className="w-full md:mx-4 md:w-1/2 md:flex-1">
              <div className="relative">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                  <HiSearch color="#c51369" className="h-5 w-5" />
                </span>
                <input
                  type="text"
                  placeholder="Search..."
                  className="block w-full rounded-md border px-4 py-2 pl-10 text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#c51369] md:w-1/2"
                />
              </div>
            </div>

            {/* plus icons */}
            <div className="flex w-full items-center gap-4 md:w-auto">
              <button className="flex w-full items-center justify-center rounded-full bg-[#c51369] p-3 text-white hover:bg-[#a10f5b] hover:shadow-lg focus:outline-none md:w-auto">
                <TbFileTypePdf className="h-5 w-5" />
              </button>

              <button className="flex w-full items-center justify-center rounded-full bg-[#c51369] p-3 text-white hover:bg-[#a10f5b] hover:shadow-lg focus:outline-none md:w-auto">
                <HiPlus className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
        <CardWidget />
        <UsersTable />
      </div>
    </React.Fragment>
  );
};

export default EngagedUsers;
